<template>
  <div>
    <div class='m_list_wrapper'>
   <router-link :to="{name:'mallItem',params:{id:item.goodID}}" class='m_list' v-for="item in mallGoods" :key="item.goodID">
    <div class='m_list_pic_wrapper'>
     <img :src='item.pic' class='m_list_pic' />
    </div>
    <div class='m_list_content_wrapper'>
     <div class='m_lsit_title'>{{item.goodName}}</div>
     <div class='m_lsit_des'>礼品描述：{{item.comment}}</div>
     <div class='m_lsit_ways'>兑换方式<span class='m_lsit_coins_num'>{{item.score}}券币</span></div>
     <!--div class='m_lsit_ways'>兑换方式2<span class='m_lsit_coins_num'>4900券币＋20元</span></div-->
     <!--div class='m_lsit_data'><div class='m_lsit_data1'><span class='icon-news2'></span> 895</div><div class='m_lsit_data1'><span class='icon-good2'></span> 4323</div></div-->
    </div>
    <div class='circle circle1'></div>
    <div class='circle circle2'></div>
   </router-link>
 </div>
  </div>
</template>
<script type="text/ecamscript-6">
import Vue from 'vue'
import { InfiniteScroll } from 'mint-ui'
import { Indicator } from 'mint-ui' //提示搜索优惠券
Vue.use(InfiniteScroll)
  export default {
    name:"mallList",
    data(){
      return{
        page:1,
        pageSize:5,
        mallGoods:[],
        REQUIRE:false
      }
    },
    created () {
      this.login()
    },
    methods:{
      /*axios调用数据*/
       login () {
         this.url = "api/getmallGoods.php?page="+this.page+"&pageSize="+this.pageSize

         this.$ajax.autoService
             .login(this.url)
             .then((res) => {
               this.mallGoods = this.mallGoods.concat(res.data.map(function(item){
                 return item
               }))
               console.log(res)
               //this.REQUIRE
               //this.loading = false
               this.$nextTick(() => {
                 this.REQUIRE = true;
                 this.loading = false;
                 Indicator.close()
                 if(res.data==0){//如果数据已无，则不滑动数据
                   this.REQUIRE = false
                 }
               });
             }, (res) => {
                 console.log("error")
                 this.REQUIRE = true;
             })
        },
        /*axios向下加载*/
        scrollBottom() {
         // 滚动到页面底部时，请求前一天的文章内容
         var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop


         if (((window.screen.height + scrollTop) > (document.body.clientHeight)-10)&& this.REQUIRE) {
           // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
           Indicator.open('正在加载');
           this.REQUIRE = false;
           this.loading = true;
           this.tips = '努力加载中...';
           this.page+=1
           this.login(this.url)

     }
   }
 },
 mounted () {
   window.addEventListener('scroll', this.scrollBottom)
 },
 beforeDestroy(){
   Indicator.close()
   window.onscroll = ""
 }


  }
</script>
<style lang="stylus">
  .m_list_wrapper
     padding: 35px 20px 0
     .m_list
      display: flex
      width: 100%
      height: 320px
      overflow: hidden
      background: #fff
      border-radius: 20px
      margin-bottom: 20px
      position: relative
      .m_list_pic_wrapper
        flex: 1
       .m_list_pic
         width: 355px
         height: 320px
         display: block
      .m_list_content_wrapper
        flex: 1
        box-sizing: border-box
        padding: 85px 30px 0 30px
        .m_lsit_title
          font-size: 28px
          color: #333
        .m_lsit_des
          font-size: 22px
          color: #999
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          line-height: 30px
          height: 60px
          overflow: hidden
          margin-top: 15px
        .m_lsit_ways
          padding-bottom: 20px
          padding-top: 20px
          line-height: 30px
          font-size: 20px
          color: #333
          vertical-align: middle
          height: 30px
          .m_lsit_coins_num
            font-size: 24px
            color: #fa4c27
            line-height: 30px
            margin-left: 10px
            display: inline-block
        .m_lsit_data
          display: flex
          padding-top: 15px
          font-size: 20px
          color: #999
          .m_lsit_data1
            flex: 1
      .circle
        width: 32px
        height: 32px
        border-radius: 16px
        background: #f94952
        position: absolute
        left: 339px
        &.circle1
          top: -16px
        &.circle
          bottom: -16px
</style>



// WEBPACK FOOTER //
// src/components/userCenter/mall/mallList.vue